import { Contentful } from './Contentful';

var spaceID = '8g6ewiuecwsq';
var accessToken = 'XRy9-JoFBnkknGJQp8iAUVwO_2KIj8Y4YGUC5lFSrwE';

export var ContentfulClient = new Contentful(spaceID, accessToken);
//# sourceMappingURL=ContentfulClient.js.map